const listBreadcrumb = {
  text: 'route.list',
  to: 'list',
  link: true
}

export default [
  {
    path: '/courses',
    name: 'Courses',
    component: () => import('@/views/tables/CoursesView.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.courses',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/reason-codes',
    name: 'ReasonCodes',
    component: () => import('@/views/tables/ReasonCodesView.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.reasonCodes',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/exam-forms',
    name: 'ExamForms',
    component: () => import('@/views/tables/ExamFormsView.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.examForms',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/exam-assessments',
    name: 'ExamAssesments',
    component: () => import('@/views/tables/ExamAssessmentsView.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.examAssessments',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/course-types',
    name: 'CourseTypes',
    component: () => import('@/views/tables/CourseTypesView.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.courseTypes',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/course-remarks',
    name: 'CourseRemarks',
    component: () => import('@/views/tables/CourseRemarks.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.courseRemarks',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/main-areas',
    name: 'MainAreas',
    component: () => import('@/views/tables/MainAreas.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.mainAreas',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/foreign-languages',
    name: 'ForeignLanguages',
    component: () => import('@/views/tables/ForeignLanguages.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.foreignLanguages',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/grades',
    name: 'Grades',
    component: () => import('@/views/tables/Grades.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.grades',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/competences',
    name: 'Competences',
    component: () => import('@/views/tables/Competences.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.competences',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/competence-sub-goals',
    name: 'CompetenceSubGoals',
    component: () => import('@/views/tables/CompetenceSubGoals.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.competenceSubGoals',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/competence-sets',
    name: 'CompetenceSets',
    component: () => import('@/views/tables/CompetenceSets.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.competenceSets',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/program-areas',
    name: 'ProgramAreas',
    component: () => import('@/views/tables/ProgramAreas.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.programAreas',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/program-area-courses',
    name: 'ProgramAreaCourses',
    component: () => import('@/views/tables/ProgramAreaCourses.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.programAreaCourses',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/program-area-categories',
    name: 'ProgramAreaCategories',
    component: () => import('@/views/tables/ProgramAreaCategories.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.programAreaCategories',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/curricula',
    name: 'Curricula',
    component: () => import('@/views/tables/Curricula.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.curricula',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/curriculalk20',
    name: 'Curriculalk20',
    component: () => import('@/views/tables/Curriculalk20.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.curriculalk20',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/countries',
    name: 'Countries',
    component: () => import('@/views/tables/Countries.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.countries',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/maalform',
    name: 'Maalform',
    component: () => import('@/views/tables/Maalform.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.maalform',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/labels',
    name: 'Labels',
    component: () => import('@/views/tables/Labels.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.labels',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/mother-tongues',
    name: 'MotherTongues',
    component: () => import('@/views/tables/MotherTongues.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.motherTongues',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/orders',
    name: 'Orders',
    component: () => import('@/views/tables/Orders.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.orders',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/schools',
    name: 'Schools',
    component: () => import('@/views/tables/Schools.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.schools',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/education-programs',
    name: 'EducationPrograms',
    component: () => import('@/views/tables/EducationPrograms.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.educationPrograms',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/diploma-remarks',
    name: 'DiplomaRemarks',
    component: () => import('@/views/tables/DiplomaRemarks.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.diplomaRemarks',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/postal-areas',
    name: 'PostalAreas',
    component: () => import('@/views/tables/PostalAreas.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.postalAreas',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/municipalities',
    name: 'Municipalities',
    component: () => import('@/views/tables/Municipalities.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.municipalities',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/counties',
    name: 'Counties',
    component: () => import('@/views/tables/Counties.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.counties',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/variables',
    name: 'Variables',
    component: () => import('@/views/tables/Variables.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.variables',
          disabled: true
        }
      ]
    }
  }
]
